import { SVGProps } from '@components/Icon/types';

export const Lock = ({ fill = '#000', size = 24, ...props }: SVGProps) => (
  <svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g transform="translate(3.5, 2)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.2222 3.80952C13.2222 1.70558 11.5309 0 9.44444 0H7.55556C5.46915 0 3.77778 1.70558 3.77778 3.80952V4.7619C1.69137 4.7619 0 6.46749 0 8.57143V16.1905C0 18.2286 1.58719 19.8932 3.58317 19.9953L3.77778 20H13.2222C15.3086 20 17 18.2944 17 16.1905V8.57143C17 6.46749 15.3086 4.7619 13.2222 4.7619V3.80952ZM5.10037 3.80952C5.10037 2.44196 6.19939 1.33371 7.55556 1.33371H9.44444C10.8006 1.33371 11.8996 2.44196 11.8996 3.80952V4.7619H5.10037V3.80952ZM10.8611 11.4286C10.8611 10.1136 9.80401 9.04762 8.5 9.04762C7.19599 9.04762 6.13889 10.1136 6.13889 11.4286C6.13889 12.5118 6.85685 13.4242 7.8387 13.7128V15.2381C7.8387 15.6063 8.13488 15.9049 8.5 15.9049C8.86512 15.9049 9.1613 15.6063 9.1613 15.2381V13.7128C10.1431 13.4242 10.8611 12.5118 10.8611 11.4286ZM8.5 10.3813C7.92624 10.3813 7.46148 10.85 7.46148 11.4286C7.46148 12.0072 7.92624 12.4758 8.5 12.4758C9.07376 12.4758 9.53852 12.0072 9.53852 11.4286C9.53852 10.85 9.07376 10.3813 8.5 10.3813Z"
        fill={fill}
      />
    </g>
  </svg>
);

export const ICON_NAME = 'lock';
